import a from "./ghl-ui.es1506.js";
import o from "./ghl-ui.es1661.js";
import m from "./ghl-ui.es1662.js";
import f from "./ghl-ui.es1466.js";
var i = 6048e5;
function g(e) {
  f(1, arguments);
  var r = a(e), t = o(r).getTime() - m(r).getTime();
  return Math.round(t / i) + 1;
}
export {
  g as default
};
